import WCOperation from "@/domain/maintenance/WCOperation";
import editable from "@/domain/decorators/editable";

export default class ProdRouteItem extends editable{
    public routeItemID = 0; // 0 indicates new
    public prodRouteItemDescription!: string;
    public prodRouteItemWorkCenter!: string;
    public prodRouteItemWorkCenterOperation!: number;
    public prodRouteItemNumberRequired!: number;
    public prodRouteItemSetupTime!: number;
    public prodRouteItemSetupRate!: number;
    public prodRouteItemMachineTime!: number;
    public prodRouteItemMachineRate!: number;
    public prodRouteItemLaborTime!: number;
    public prodRouteItemLaborRate!: number;
    public prodRouteItemCycleCount!: number;
    public productBomID!: number;
    public prodRouteItemWcOperationID?: number;
    public prodRouteItemLineNumber!: number; //From productBom
    public prodRouteItemQuantity!: number; //Client side only/moved to Product BOM
    public prodRouteItemOverrideFlag!: boolean;
    public prodRouteItemAssemblyStepTime!: number;
    public prodRouteItemTotalAsmTime!: string;
    public prodRouteItemCostQty1!: number;
    public prodRouteItemCostQty2!: number;
    public prodRouteItemCostQty3!: number;
    public prodRouteItemCostQty4!: number;
    public prodRouteItemCostQty5!: number;

    //WC_Operations table
    public prodRouteItemWcOperation!: WCOperation;

    constructor(init?: Partial<ProdRouteItem>) {
        super();
        Object.assign(this, init);
    }

    public compareTo(val: ProdRouteItem): number {
        return this.prodRouteItemLineNumber > val.prodRouteItemLineNumber ? 1 :
            this.prodRouteItemLineNumber === val.prodRouteItemLineNumber ? 0 :
                -1;
    }
}
